module.exports = __webpack_public_path__ + "img/americanfortress.16a00c64.svg";